import { Injectable, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TeamListDto } from '../../models/teams/team-list-dto';
import { TeamListFilter } from '../../models/teams/team-list-filter';
import { TeamApiService } from '../api/team-api.service';

@Injectable({
  providedIn: 'root'
})
export class TeamListService {
  private dataSubject = new BehaviorSubject<TeamListDto[] | null>(null);
  data$ = this.dataSubject;

  constructor(private teamApiService: TeamApiService) {
  }

  @Output() filterChange = new BehaviorSubject<TeamListFilter>({
    search: [],
    productionTechnicianArea: [],
    productionLeader: [],
    ownerType: [],
    status: [],
  });

  async loadTeams() {
    this.teamApiService.getTeamList().subscribe(data => {
      this.dataSubject.next(data)
    });
  }

  applyFilter(filterValues: TeamListFilter | undefined) {
    filterValues ? this.filterChange.next(filterValues) : console.log('no filter found');
  }
}
